import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class AdminUpdateUserPenNameLimitArgs {
  @Field(t => Int)
  userId!: number

  // How many pen names the account may create in total, no lower than the default every account starts
  // on. There is no unlimited: a number nobody will reach does the same job.
  @Field(t => Int)
  penNameLimit!: number
}
